import styles from './ScrollToTop.module.css'
import { Button, Col, Row } from "react-bootstrap";

export default function ScrollToTop() {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }

    return (
        <Row className="mt-5 mb-5 justify-content-center align-items-center m-auto p-0">
            <Col xs="12" sm="12" md="12" lg="12" className='m-auto p-0 text-center'>
                <Button className={styles.button} variant="outline-light" onClick={scrollToTop}>Scroll to top</Button>
            </Col>
        </Row>
    )
}